import { Helper } from "../util/helper.js";
import { HTTPService } from "../util/httpManager.js";
import { Commands } from "../util/commandManager.js";
import { BaseDataSourceComponentProps, BaseDataSourceField } from "./baseComponentProps.js";
import { CommandManagerAPI } from "../../commonInterfaces.js";
import React from "react";
export class MultiSelect extends React.Component<MultiSelectProps, any>{
    private _multiSelectRef: any;
    private _multiSelect: kendo.ui.MultiSelect;
    private _disabled = true;
    private _icuh = Helper;
    static isCtrlPressed = false;
    static {
        // Event-Handler für keydown und keyup
        const handleKeyDown = (event) => {
            if (event.ctrlKey) {
                MultiSelect.isCtrlPressed = true;
            }
        };

        const handleKeyUp = (event) => {
            if (!event.ctrlKey) {
                MultiSelect.isCtrlPressed = false;
            }
        };

        // Event-Handler für blur (wenn das Fenster den Fokus verliert)
        const handleBlur = () => {
            MultiSelect.isCtrlPressed = false;
        };
        // Event-Listener hinzufügen
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        window.addEventListener('blur', handleBlur);
    }
    constructor(props) {
        super(props)
    }

    componentWillUnmount() {
        this._multiSelect.destroy();
    }

    setValue(triggerChange = false) {
        this._multiSelect.dataSource.filter({});
        let value = this._icuh.hasValue(this.props.value) ? this.props.value : [];
        if (this.props.field.primitiveValue === true) {
            this._multiSelect.value(value);
        } else {
            if (Array.isArray(value)) {
                let tmp = value.map((e) => {
                    return e[this.props.field.dataValueField];
                });
                this._multiSelect.value(tmp);
            }
        }
        if (value.length > 0) {
            $(this._multiSelectRef).closest(".k-widget.k-multiselect").addClass("multiselect--has-value");
        } else {
            $(this._multiSelectRef).closest(".k-widget.k-multiselect").removeClass("multiselect--has-value");
        }

        if (triggerChange) {
            this._multiSelect.trigger("change");
        }
    }

    setDataSourceItems(items) {
        this._multiSelect.dataSource.data(items);
    }

    setEnabled(enabled: boolean) {
        if (this._disabled != !enabled) {
            this._disabled = !enabled;
            this._multiSelect.readonly(this._disabled);
        }
    }

    componentDidMount() {
        this._disabled = this.props.disabled;
        var that = this;
        let lastSelected = null;
        this._multiSelect = $(this._multiSelectRef).kendoMultiSelect({
            maxSelectedItems: this.props.field.maxSelectedItems,
            dataSource: this.props.dataSource,
            dataTextField: this.props.field.dataTextField,
            dataValueField: this.props.field.dataValueField,
            height: 300,
            valuePrimitive: this.props.field.primitiveValue === true,
            itemTemplate: this.props.field.template,
            select: (e) => {
                lastSelected = e.dataItem[that.props.field.dataValueField];
            },
            change: (ev) => {
                const privateLastSelected = lastSelected;
                lastSelected = null;
                if (MultiSelect.isCtrlPressed) {
                    that.props.onChange(that.props.field, privateLastSelected, ev.sender.dataItems());
                }
                else {
                    that.props.onChange(that.props.field, (that.props.field.primitiveValue === true ? ev.sender.value() : ev.sender.dataItems()), ev.sender.dataItems());
                }

            },
            tagTemplate: this.props.field.displayTemplate,
            filter: this.props.field.searchFilter || "startswith"
        }).data("kendoMultiSelect");
        this.setValue()
        this._multiSelect.readonly(this._disabled);
        this._multiSelect.wrapper.attr("data-readonly", this._disabled.toString());

        if (this.props.field.listWidth !== null && window.matchMedia(`(min-width: ${this.props.field.listWidth}px)`).matches) {
            this._multiSelect.list.width(this.props.field.listWidth);
            //https://feedback.telerik.com/kendo-jquery-ui/1579615-there-is-delay-in-expadning-when-the-dropdowntree-popup-is-opened-and-the-list-width-is-set
            this._multiSelect.list.parent().width(this.props.field.listWidth);
        }

        if (this.props.field.dataSourceUrl !== undefined && this.props.field.dataSourceUrl !== null && this.props.field.dataSourceUrl !== "") {
            HTTPService.get(that.props.field.dataSourceUrl)
                .then(data => {
                    that._multiSelect.setDataSource(data);
                    that.setState({});
                    //wenn keine DS setzt Kendo keinen Wert -- muss wieder gesetzt werden
                    that.setValue();
                    that.props.onDataLoaded(that.props.field, data);
                }
                );
        }

        if (this._icuh.hasValue(this.props.commandManager)) {
            this.props.commandManager.registerExecutor(this.props.field.model, (command, data) => {
                if (command === Commands.RELOADDATASOURCE) {
                    this._multiSelect.dataSource.data(this.props.dataSource);
                    let validValue = true;

                    if (!Array.isArray(this.props.value)) {
                        validValue = true;
                    } else {
                        const dsValues = [];
                        for (let i = 0; i < this.props.dataSource.length; i++) {
                            let v = this._icuh.getValueByPathString(this.props.dataSource[i], this.props.field.dataValueField);
                            dsValues.push(v);
                        }
                        for (let i = 0; i < this.props.value.length; i++) {
                            if (dsValues.indexOf(this.props.value[i]) === -1) {
                                validValue = false;
                                break;
                            }
                        }
                    }
                    if (validValue) {
                        this.setValue();
                    } else {
                        this.setValue(true);
                    }
                }
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this._disabled !== isDisabled) {
            this._disabled = isDisabled;
            this._multiSelect.readonly(this._disabled);
            this._multiSelect.wrapper.attr("data-readonly", this._disabled.toString());
        }
        this.setValue();
    }

    udpateFocus = () => {
        this._multiSelectRef.focus();
    }


    render() {
        let style = $.extend({ width: "100%" }, this.props.style);
        return (
            <div style={{ flex: "1" }} className="is-multiselect">
                <select ref={(r) => this._multiSelectRef = r} name={this.props.field.model} style={style} required={this.props.required} data-label={this.props.field.name} />
            </div>
        );
    }
}
export interface MultiSelectProps extends BaseDataSourceComponentProps {
    field: MultiSelectField;
    style?: any;
    commandManager?: CommandManagerAPI;
}

export interface MultiSelectField extends BaseDataSourceField {
    listWidth?: number;
    primitiveValue?: boolean;
    displayTemplate?: string;
    template?: string;
    maxSelectedItems?: number;
    searchFilter?: "startswith" | "endwith" | "contains"
}